import { Alert, Box, Typography } from "@mui/material";
import { useRegisterControladoriaPageActions } from "./layout";
import useDashboardData from "./hooks/useDashboardData";
import KpiCards from "./dashboard/KpiCards";
import VinculoStatusChart from "./dashboard/VinculoStatusChart";
import EntregaStatusChart from "./dashboard/EntregaStatusChart";

const Dashboard = () => {
  const { loading, refreshing, data, error, refresh } = useDashboardData();

  useRegisterControladoriaPageActions({
    onRefresh: refresh,
    refreshing,
  });

  const periodoLabel = data.periodo
    ? `Últimos ${data.periodo.dias} dias (${data.periodo.inicio} → ${data.periodo.fim})`
    : "Últimos 30 dias";

  return (
    <Box
      sx={{
        flex: 1,
        minHeight: 0,
        overflow: "auto",
        p: { xs: 2.5, md: 3.5 },
        boxSizing: "border-box",
      }}
    >
      <Box sx={{ mb: 3, maxWidth: 720 }}>
        <Typography
          sx={{
            fontSize: { xs: 22, md: 28 },
            fontWeight: 800,
            letterSpacing: "-0.02em",
            color: "var(--ctrl-text)",
            mb: 0.75,
          }}
        >
          Dashboard
        </Typography>
        <Typography
          sx={{
            fontSize: 14,
            lineHeight: 1.55,
            color: "var(--ctrl-text-muted)",
            maxWidth: 560,
          }}
        >
          Gargalos do fluxo SC → PC → NF e saldo em aberto. {periodoLabel}.
        </Typography>
      </Box>

      {error && (
        <Alert severity="error" sx={{ mb: 2.5 }}>
          {error}
        </Alert>
      )}

      <KpiCards kpis={data.kpis} loading={loading} />

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            lg: "minmax(0, 1fr) minmax(0, 1.35fr)",
          },
          gap: 2,
        }}
      >
        <VinculoStatusChart vinculoPc={data.vinculoPc} loading={loading} />
        <EntregaStatusChart entrega={data.entrega} loading={loading} />
      </Box>
    </Box>
  );
};

export default Dashboard;
